import { useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
import { userTaskHostDefaultService } from '../../../../../services/users-tasks/defaults/users-tasks-hosts-defaults'
import type { GetList } from '../../../../../services/users-tasks/defaults/users-tasks-hosts-defaults/types'

export const USERS_TASKS_HOSTS_DEFAULTS_QUERY_KEY = 'getUsersTasksDefaultsHosts'
export const useGetUsersTasksDefaultsHosts = (take = 20) => {
  const [params, setParams] = useState({} as GetList.Input)

  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [USERS_TASKS_HOSTS_DEFAULTS_QUERY_KEY, params],
      initialPageParam: 0,
      staleTime: Infinity,
      queryFn: ({ pageParam: skip }) => {
        return userTaskHostDefaultService.getList({
          take,
          skip,
          ...params,
        })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  const get = useCallback(
    (params: GetList.Input) => {
      setParams(params)
    },
    [setParams],
  )

  return {
    usersTasksHostsDefaults: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
    get,
  }
}
